export default function LeagueStandingSidebar({ standings, colorInfos = [] }) {
  if (!Array.isArray(standings) || standings.length === 0) return null;

  const sorted = [...standings].sort((a, b) => Number(a.rank) - Number(b.rank));

  return (
    <div className="kbv-bxh-sb-card">
      <table className="kbv-bxh-sb-table">
        <thead>
          <tr>
            <th className="is-rank">#</th>
            <th className="is-team">Đội</th>
            <th className="is-num">Tr</th>
            <th className="is-num">Đ</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((row) => {
            const team = row.teams;
            const colorIndex = Number(row.color);
            const rankBgColor =
              !Number.isNaN(colorIndex) &&
              colorIndex >= 0 &&
              colorInfos?.[colorIndex]?.color
                ? colorInfos[colorIndex].color
                : null;

            return (
              <tr key={row.id}>
                <td className="is-rank">
                  <span
                    className={`kbv-bxh-sb-rank ${rankBgColor ? "has-color" : ""}`}
                    style={rankBgColor ? { backgroundColor: rankBgColor } : undefined}
                  >
                    {row.rank}
                  </span>
                </td>
                <td className="is-team">
                  <div className="kbv-bxh-sb-team">
                    {team?.logo ? (
                      <span className="kbv-bxh-sb-team-logo">
                        <img src={team.logo} alt="" />
                      </span>
                    ) : (
                      <span className="kbv-bxh-sb-team-logo is-fallback">
                        {(team?.name || "?").trim().charAt(0).toUpperCase()}
                      </span>
                    )}
                    <span className="kbv-bxh-sb-team-name" title={team?.name}>
                      {team?.name || "-"}
                    </span>
                  </div>
                </td>
                <td className="is-num">{row.totalCount}</td>
                <td className="is-num is-pts">{row.integral}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
